import Cookies from 'js-cookie';

export const getProfile = () => {
    try {
        return JSON.parse(Cookies.get("profile").replaceAll('+', ' '));
    }
    catch (e) { return null; }
  }

  